import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
} from "react-router-dom";
import { NotificationProvider } from "./context/NotificationContext";
import { ChatProvider } from "./context/ChatContext";
import { SettingsProvider } from "./context/SettingsContext";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import More from "./pages/More";
import "./App.css";

// Wrapper component that provides navigation to NotificationProvider
const AppContent = () => {
  const navigate = useNavigate();

  return (
    <SettingsProvider>
      <NotificationProvider navigate={navigate}>
        <ChatProvider>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route
                path="/navigate"
                element={
                  <div style={{ padding: "20px", textAlign: "center" }}>
                    Navigate Page (Coming Soon)
                  </div>
                }
              />
              <Route
                path="/explore"
                element={
                  <div style={{ padding: "20px", textAlign: "center" }}>
                    Explore Page (Coming Soon)
                  </div>
                }
              />
              <Route
                path="/commute"
                element={
                  <div style={{ padding: "20px", textAlign: "center" }}>
                    Commute Page (Coming Soon)
                  </div>
                }
              />
              <Route path="/more" element={<More />} />
            </Routes>
          </Layout>
        </ChatProvider>
      </NotificationProvider>
    </SettingsProvider>
  );
};

function App() {
  return (
    <div className="app">
      <Router>
        <AppContent />
      </Router>
    </div>
  );
}

export default App;
